import { useState } from 'react';
import { supabase } from './lib/supabase.js';
import { RecoveryLogin } from './Mfa.jsx';
import { MFA_ENABLED } from './lib/featureFlags.js';

function Login() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [error, setError] = useState(null);
  const [mode, setMode] = useState('login'); // login | recovery

  if (MFA_ENABLED && mode === 'recovery') return <RecoveryLogin onCancel={() => setMode('login')} />;

  async function submit(e) {
    e.preventDefault();
    if (!email) return;
    setStatus('sending');
    setError(null);
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin },
    });
    if (error) {
      setStatus('error');
      setError(error.message);
    } else {
      setStatus('sent');
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'grid',
      placeItems: 'center',
      background: '#0B0D13',
      color: 'var(--ink)',
      fontFamily: 'var(--sans)',
      padding: 24,
    }}>
      <div style={{
        width: 420,
        maxWidth: '100%',
        background: 'var(--bg-elev)',
        border: '1px solid var(--stroke-2)',
        borderRadius: 'var(--radius-xl)',
        padding: 36,
        boxShadow: 'var(--shadow-lg)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img
            src="/assets/markenegger-wordmark.png"
            alt="Markenegger"
            style={{ height: 28, opacity: 0.95, filter: 'invert(1) hue-rotate(180deg) brightness(1.05)' }}
          />
          <div className="eyebrow" style={{ marginTop: 14 }}>Projekte & Zeit</div>
          <h1 className="serif" style={{ fontSize: 26, fontWeight: 500, margin: '8px 0 0', letterSpacing: '-0.01em' }}>
            Willkommen zurück.
          </h1>
        </div>

        {status === 'sent' ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: 52, height: 52, borderRadius: '50%',
              background: 'var(--ok-soft)', color: 'var(--ok)',
              display: 'grid', placeItems: 'center',
              margin: '0 auto 14px', fontSize: 28,
            }}>✓</div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Link ist unterwegs.</div>
            <div className="tiny muted" style={{ marginTop: 8, lineHeight: 1.5 }}>
              Schau in deinem Postfach ({email}). Der Login-Link ist 10 Minuten gültig.
            </div>
            <button
              className="btn btn-ghost"
              style={{ marginTop: 20 }}
              onClick={() => { setStatus('idle'); setEmail(''); }}
            >
              Andere E-Mail
            </button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div className="field">
              <label>E-Mail-Adresse</label>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="du@markenegger.com"
                autoFocus
                required
                disabled={status === 'sending'}
              />
            </div>
            {error && (
              <div className="tiny" style={{ color: 'var(--crit)', marginTop: 10 }}>{error}</div>
            )}
            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', marginTop: 16, opacity: status === 'sending' ? 0.6 : 1 }}
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Sende Link…' : 'Login-Link per E-Mail senden'}
            </button>
            <div className="tiny muted" style={{ marginTop: 16, textAlign: 'center', lineHeight: 1.5 }}>
              Kein Passwort. Wir schicken dir einen Link — einen Klick drauf und du bist drin.
            </div>
            {MFA_ENABLED && (
              <div className="tiny muted" style={{ marginTop: 12, textAlign: 'center' }}>
                Authenticator-Gerät verloren?{' '}
                <button type="button" onClick={() => setMode('recovery')}
                  style={{ background: 'none', border: 'none', padding: 0, color: 'var(--accent)', cursor: 'pointer', textDecoration: 'underline' }}>
                  Mit Wiederherstellungs-Code anmelden
                </button>
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
}

export default Login;
